import { render } from "./AffiliatePage.vue?vue&type=template&id=8d3973da"
import script from "./AffiliatePage.vue?vue&type=script&lang=js"
export * from "./AffiliatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__